import { render, staticRenderFns } from "./culturalPalace.vue?vue&type=template&id=45dda85b&scoped=true&"
import script from "./culturalPalace.vue?vue&type=script&lang=js&"
export * from "./culturalPalace.vue?vue&type=script&lang=js&"
import style0 from "./culturalPalace.vue?vue&type=style&index=0&id=45dda85b&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45dda85b",
  null
  
)

component.options.__file = "culturalPalace.vue"
export default component.exports